export default __webpack_public_path__ + "static/undraw_Analytics_re_dkf8-7db258b50348d7feb1828c4b3f7342e1.svg";